module.exports = __webpack_public_path__ + "img/tag-icon-1.41046dd3.png";